module.exports = __webpack_public_path__ + "static/media/fire_in_the_sky.ca3a4be9.jpg";